module.exports = __webpack_public_path__ + "img/3.77075755.png";